import { connectPagination } from 'react-instantsearch-dom'
import React, {useLayoutEffect, useRef} from 'react'

import chevronRight from '../../icons/chevron-right.svg'

const Pagination = ({ currentRefinement, nbPages, refine, createURL, forcedPage = false }) => {
  let searchContainer = useRef(null)

  useLayoutEffect(() => {
    searchContainer.current = document.querySelector('.search-container-wrapper')

    if (forcedPage !== false) {
      refine(forcedPage)
    }
  }, [searchContainer, forcedPage, refine])

  return (
    <>
    { nbPages > 1 &&
      <ul className="pagination">
        { currentRefinement > 1 &&
          <li className="pagination__item pagination__item--prev">
            <button
              className="pagination__arrow pagination__arrow--prev"
              onClick={event => {
                event.preventDefault()
                refine(currentRefinement - 1)
                if(window.pageYOffset > searchContainer.current.offsetTop - 40) {
                  window.scrollTo({
                    top: searchContainer.current.offsetTop - 40,
                    behavior: 'smooth'
                  })
                }
              }}
            >
              <span className="sr-only">Prev</span>
              <svg className="icon-grey" width="32" height="32">
                <use xlinkHref={chevronRight.url} />
              </svg>
            </button>
          </li>
        }
        {new Array(nbPages).fill(null).map((_, index) => {
          let showingIndexes = [1, currentRefinement - 1, currentRefinement, currentRefinement + 1, nbPages]

          for (let i = 1; i <= nbPages; i++) {
            if ((i - 3) > 0 && (i - 3) % 6 === 0) {
              showingIndexes.push(i)
            }
          }

          if( currentRefinement === 1) {
            Array.prototype.push.apply(showingIndexes, [nbPages - 1])
          }

          if (currentRefinement === 1 || currentRefinement === 2) {
            Array.prototype.push.apply(showingIndexes, [3])
          }

          if (currentRefinement === nbPages - 1 || currentRefinement === nbPages) {
            Array.prototype.push.apply(showingIndexes, [nbPages - 2])
          }

          return (
            <React.Fragment key={index}>
            { (nbPages < 10 || (nbPages > 9 && showingIndexes.includes(index + 1)) ) &&
              <li className="pagination__item">
                <button
                  className={`pagination__page ${currentRefinement === index + 1 ? 'is-active' : ''}`}
                  onClick={event => {
                    event.preventDefault()
                    refine(index + 1)

                    if(window.pageYOffset > searchContainer.current.offsetTop - 40) {
                      window.scrollTo({
                        top: searchContainer.current.offsetTop - 40,
                        behavior: 'smooth'
                      })
                    }
                  }}
                >
                  {index + 1}
                </button>
              </li>
            }
            { (nbPages > 9 && showingIndexes.includes(index) && !showingIndexes.includes(index + 1)) &&
              <li className="pagination__item">...</li>
            }
            </React.Fragment>
          )
        })}
        { currentRefinement < nbPages &&
          <li className="pagination__item pagination__item--next">
            <button
              className="pagination__arrow pagination__arrow--next"
              onClick={event => {
                event.preventDefault()
                refine(currentRefinement + 1)
                if(window.pageYOffset > searchContainer.current.offsetTop - 40) {
                  window.scrollTo({
                    top: searchContainer.current.offsetTop - 40,
                    behavior: 'smooth'
                  })
                }
              }}
            >
              <span className="sr-only">Next</span>
              <svg className="icon-grey" width="32" height="32">
                <use xlinkHref={chevronRight.url} />
              </svg>
            </button>
          </li>
        }
      </ul>
    }
    </>
  )
}

const CustomPagination = connectPagination(Pagination)

export default CustomPagination